import { render, staticRenderFns } from "./EditDomain.vue?vue&type=template&id=90c9c9aa&scoped=true&"
import script from "./EditDomain.vue?vue&type=script&lang=js&"
export * from "./EditDomain.vue?vue&type=script&lang=js&"
import style0 from "./EditDomain.vue?vue&type=style&index=0&id=90c9c9aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c9c9aa",
  null
  
)

export default component.exports